export default[
    {
        show(row,extra){
            return(
                row.shbj==='1'
            )
        },
        tag:'my-tag',
        type:'primary',
        text(row){
            return '已提交';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='0'
            )
        },
        tag:'my-tag',
        type:'warning',
        text(row){
            return '未提交';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='2'
            )
        },
        tag:'my-tag',
        type:'success',
        text(row){
            return '已通过';
        }
    },{
        show(row,extra){
            return(
                row.shbj==='3'
            )
        },
        tag:'my-tag',
        type:'danger',
        text(row){
            return '退回';
        }
    },
]